import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Paginator as FoundationsPaginator } from 'foundations-components/transitional/components/Paginator';
import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import unescapedText from 'I18n/utils/unescapedText';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';

// The maximum number of records crmsearch can page through
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RESULTSET_LIMIT = 10000;
const Paginator = t0 => {
  const $ = _c(17);
  const {
    pageIndex,
    pageSize,
    pageSizes,
    maxVisiblePageButtons,
    paginatorAlignment,
    totalRowCount,
    onPageIndexChange,
    onPageSizeChange
  } = t0;
  const pageCount = Math.ceil(totalRowCount / pageSize);
  let t1;
  if ($[0] !== onPageIndexChange) {
    t1 = t2 => {
      const {
        target: t3
      } = t2;
      const {
        value
      } = t3;
      return onPageIndexChange({
        nextPageIndex: value - 1
      });
    };
    $[0] = onPageIndexChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePageChange = t1;
  const t2 = paginatorAlignment === "start" ? "start" : "center";
  const t3 = pageIndex + 1;
  const t4 = RESULTSET_LIMIT / pageSize;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.pagination.tooManyRecords"
    });
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== handlePageChange || $[4] !== maxVisiblePageButtons || $[5] !== pageCount || $[6] !== t3 || $[7] !== t4) {
    t6 = /*#__PURE__*/_jsx(FoundationsPaginator, {
      "data-test-id": "table-paginator",
      page: t3,
      pageCount: pageCount,
      maxVisiblePageButtons: maxVisiblePageButtons,
      onPageChange: handlePageChange,
      enabledPageLimit: t4,
      disabledPageTooltipTitle: t5
    });
    $[3] = handlePageChange;
    $[4] = maxVisiblePageButtons;
    $[5] = pageCount;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onPageSizeChange || $[10] !== pageSize || $[11] !== pageSizes) {
    t7 = pageSizes.length >= 1 && /*#__PURE__*/_jsx(Dropdown, {
      "data-test-id": "table-page-size-selector",
      "data-test-value": pageSize,
      buttonUse: "transparent",
      buttonText: unescapedText("datatable.pagination.pageCountButton", {
        count: pageSize
      }),
      children: /*#__PURE__*/_jsx(List, {
        children: pageSizes.map(size => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": `page-size-${size}`,
            use: "link",
            onClick: () => onPageSizeChange({
              nextPageSize: size
            }),
            children: unescapedText("datatable.pagination.pageCountButton", {
              count: size
            })
          })
        }, size))
      })
    });
    $[9] = onPageSizeChange;
    $[10] = pageSize;
    $[11] = pageSizes;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t6 || $[15] !== t7) {
    t8 = /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: t2,
      marginBlockStart: "100",
      marginBlockEnd: "100",
      children: [t6, t7]
    });
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default Paginator;